import script from "./TeamReportTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamReportTable.vue?vue&type=script&lang=ts&setup=true"

import "./TeamReportTable.vue?vue&type=style&index=0&id=7392c4fe&lang=sass"

const __exports__ = script;

export default __exports__